import { render } from "./PBLPanel.vue?vue&type=template&id=e11f953e&scoped=true"
import script from "./PBLPanel.vue?vue&type=script&lang=ts"
export * from "./PBLPanel.vue?vue&type=script&lang=ts"

import "./PBLPanel.vue?vue&type=style&index=0&id=e11f953e&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-e11f953e"

export default script